import { render, staticRenderFns } from "./EditPaperPagesV2.vue?vue&type=template&id=33adfc80&scoped=true"
import script from "./EditPaperPagesV2.vue?vue&type=script&lang=js"
export * from "./EditPaperPagesV2.vue?vue&type=script&lang=js"
import style0 from "./EditPaperPagesV2.vue?vue&type=style&index=0&id=33adfc80&prod&scoped=true&lang=css"
import style1 from "./EditPaperPagesV2.vue?vue&type=style&index=1&id=33adfc80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33adfc80",
  null
  
)

export default component.exports